import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";

export interface IProduct {
  id: number
  code: string
  title: string
  status: number
  carLineId: number
  carLineTitle: string
  typeVehicleId: number
  typeVehicleTitle: string
  groupVehicleId: number
  groupVehicleTitle: string
}



//Danh sách nhóm sản phẩm
// export const getListProduct = async (
//   limit?: number, pageNumber?: number, search?: string, carLineId?: number,
//   typeVehicleId?: number, groupVehicleId?: number
// ) => {
//   const path = "vehicleProduct/listVehicleProduct"
//   const params = {
//     limit, pageNumber, search, carLineId,
//     typeVehicleId, groupVehicleId
//   }
//   const result: ResponseSuccessTotal<IProduct[]> = await axiosClient.get(
//     path, { params }
//   );
//   return result;
// };

//Thông tin nhóm sản phẩm
export const getInfoProduct = async (
  id: number) => {
  const path = "vehicleProduct/infoVehicleProduct"
  const params = {
    id
  }
  const result: ResponseSuccess<IProduct> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thêm mới nhóm sản phẩm
export const addProduct = async (
  code: string, title: string, carLineId: number, typeVehicleId: number,
  groupVehicleId: number
) => {
  const url = "vehicleProduct/addVehicleProduct";
  const params = {
    code, title, carLineId, typeVehicleId,
    groupVehicleId
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa nhóm sản phẩm
export const editProduct = async (
  id: number, code: string, title: string, carLineId: number,
  typeVehicleId: number, groupVehicleId: number
) => {
  const url = "vehicleProduct/editVehicleProduct";
  const params = {
    id, code, title, carLineId,
    typeVehicleId, groupVehicleId
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa nhóm sản phẩm
export const deleteProduct = async (
  id: number[]
) => {
  const url = `vehicleProduct/deleteVehicleProduct`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

export const updateActiveProduct = async (
  id: number) => {
  const path = "vehicleProduct/activeVehicleProduct"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

export const activeVehicleGroup = async (
  id: number) => {
  const path = "/vehicleGroup/activeVehicleGroup"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};